import { preloadHomeWidgets } from './preloadHomeWidgets';

export const preloadSidePanel = ({ isLicensed }: { isLicensed: boolean }) => {
	const preloadQueries = [preloadHomeWidgets({ isLicensed })];
	return Promise.all(preloadQueries);
};
